import { HttpInterceptorFn } from '@angular/common/http';
import { ICartService, ICartServiceToken } from '../services/data/cart/cart-service.interface';
import { inject } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const httpExportInterceptor: HttpInterceptorFn = (req, next) => {
  let cartService: ICartService | null = inject(ICartServiceToken, { optional: true });
  let cart = cartService?.cartCurrent;

  let countryCodeHeaderName: string = 'DeliveryCountryCode';
  let countryCodeHeader: string | undefined = undefined;

  if (cart?.deliveryAddressData?.countryCode == undefined) {
    return next(req);
  }

  countryCodeHeader = cart.deliveryAddressData.countryCode;
  if (countryCodeHeader == undefined) {
    return next(req);
  }

  let reqClone = req.clone({
    headers: req.headers.set(countryCodeHeaderName, `${countryCodeHeader}`)
  });
  return next(reqClone);
};
